import * as React from "react";
import Select from "react-select";

export const DropDown = ({ selected, setSelected, options }) => {
  return (
    <Select
      options={options}
      onChange={(opt: ISelectOption) => setSelected(opt.value)}
      value={selected}
      clearable={false}
      className={"ReactSelectYearPicker"}
    />
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/DropDown.tsx